<div *ngIf="viewModel$ | async as vm" class="is-relative">

  <lib-chart
    [class.blur]="vm.loading"
    [config]="vm.config"
    [apiScale]="vm.apiScale"
    [bounds]="vm.bounds"
    [enablePan]="false"
    [enableSwipe]="false">
  </lib-chart>
  <app-cp-compare-no-data *ngIf="vm.measureCards.length === 0"></app-cp-compare-no-data>

  <app-cp-compare-no-data-yet *ngIf="vm.measureCards.length > 0 && !vm.loading && hasNoData()"></app-cp-compare-no-data-yet>

  <div *ngIf="vm.loading" class="is-overlay is-flex is-justify-center is-align-center text-32">
    <div class="is-loading-overlay"></div>
  </div>

  <app-graph-tooltip></app-graph-tooltip>

</div>